import React from "react";
import {
  applestore,
  batteryFull,
  googleplay,
  heroImg2,
  heroImg3,
  heroImg4,
} from "../../../assets/images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero: React.FC = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
  };

  const carSlider = [
    // {
    //   img: heroImg1,
    // },
    {
      img: heroImg2,
    },
    {
      img: heroImg3,
    },
    {
      img: heroImg4,
    },
  ];
  return (
    <div className="bg-white overflow-hidden">
      <div className="flex container w-[90%] mx-auto  pb-[60px] pt-0 md:pt-16 space-x-8 space-y-8 gap-8 items-center flex-col lg:flex-row lg:justify-between">
        <div className="flex flex-col space-y-3 w-full md:justify-center  lg:w-1/2">
          <div className="flex space-x-3 items-center">
            <img
              src={batteryFull}
              alt=""
              className="p-1 md:p-2 rounded-full border-black"
            />
            <p className=" text-midGreen font-Poppins text-[15px] lg:text-[32px] font-medium leading-8 tracking-wider">
              FOR YOUR NEXT ADVENTURE
            </p>
          </div>
          <div className="w-full lg:w-3/5">
            <h1 className="text-darkGreen md:w-[100%] md:text-center leading-tight text-edge-cap font-Poppins text-[50px] md:text-[70px] lg:text-[80px] font-extrabold tracking-tighter uppercase text-center lg:text-left">
              ELECTRIC VEHICLE RENTAL
            </h1>
            <p className="text-black font-Poppins font-normal text-[16px] w-[80%] mx-auto lg:mx-0 leading-6 text-center md:text-left">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam,
              voluptatibus.
            </p>
          </div>
          <div className=" flex gap-2 mx-auto lg:mx-0 ">
            <img src={applestore} alt="" className="cursor-pointer" />
            <img src={googleplay} alt="" className="cursor-pointer" />
          </div>
        </div>
        <div className="w-full lg:w-1/2 relative mx-auto ">
          <div className="flex w-[90%] h-[150px] md:h-[240px] lg:h-[200px] xl:h-[269px] rounded-[10px] lg:rounded-[39px] bg-gradient-to-l  from-tealTransparent to-[#2FF77A] shadow-xl absolute left-0 top-0 translate-y-1/2"></div>
          <div className="">
            <Slider {...settings} className="flex items-center justify-center">
              {carSlider.map((car, index) => {
                return (
                  <div
                    className="w-[100%] flex items-end justify-end place-content-end place-items-end"
                    key={index}
                  >
                    <img src={car.img} alt="" className="mx-auto mt-auto" />
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
